import React from "react";
import { Play, Home } from "lucide-react";

export function PauseModal({ onResume, onReturnToMenu }: { onResume: () => void, onReturnToMenu: () => void }) {
  return (
    <div className="absolute inset-0 bg-black/60 flex items-center justify-center pointer-events-auto z-50">
      <div className="bg-gray-800 p-8 rounded-xl shadow-2xl text-center text-white border-2 border-gray-700 min-w-[320px]">
        <h2 className="text-4xl font-bold mb-4">Paused</h2>
        <p className="text-lg mb-8">Game is paused. Press resume to continue.</p>
        <div className="flex flex-col items-center gap-4 w-full">
            <button
              onClick={onResume}
              className="w-full flex items-center justify-center gap-3 bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold py-3 px-8 rounded-lg text-2xl transition-transform transform hover:scale-105"
            >
              <Play />
              Resume
            </button>
            <button
              onClick={onReturnToMenu}
              className="w-full flex items-center justify-center gap-3 bg-gray-600 hover:bg-gray-500 text-white font-bold py-2 px-6 rounded-lg text-xl transition-transform transform hover:scale-105"
            >
              <Home className="w-6 h-6" />
              Main Menu
            </button>
        </div>
      </div>
    </div>
  );
}
